import React from "react";

function ListPage() {
  return <div>listpage</div>;
}

export default ListPage;
